/**
 * The sections of one group's page, in display order, as the address names them
 * in `?aba=`. A tab with the same name as one on the company page has the same
 * slug there, so somebody moving between the two finds the same word in the
 * same place and the same address. The first is the default.
 */
export const GROUP_TABS = {
  geral: 'Geral',
  regras: 'Validações e regras',
  segurados: 'Segurados',
  usuarios: 'Usuários',
} as const;

export type GroupTab = keyof typeof GROUP_TABS;

/** The tablist's accessible name. */
export const GROUP_TABS_LABEL = 'Seções do grupo';
